import Badge from "../shared-components/Badge";
import { ThreeSixtyQueueingRow } from "../api/ThreeSixty";
import { GenericObject } from "./FilterSortHeader";
import { usePermissionValidator } from "../api/UserPermissionValidators";
import { ThreeSixtyRowRendererBase } from "./ThreeSixtyRowRendererBase";

type ThreeSixtyQueuingRowProps = {
  row: ThreeSixtyQueueingRow | GenericObject;
  cancel: string[];
  toggleCancel: (value: string) => number;
};

export const ThreeSixtyQueuingRowRenderer = (
  props: ThreeSixtyQueuingRowProps
) => {
  const { row, cancel, toggleCancel } = props;
  const perms = usePermissionValidator();

  return (
    <ThreeSixtyRowRendererBase
      row={row}
      cancel={cancel}
      toggleCancel={toggleCancel}
      linkPath="/workbench"
      canShowLink={perms.canViewWIP360Reports || perms.canEdit360Reports}
      afterCheckTypeColumns={
        <div className="flex-1 flex items-center">
          <Badge hasDot={false}>{row.misconduct_step}</Badge>
        </div>
      }
    />
  );
};
